module.exports = __webpack_public_path__ + "files/67898aa7444465601d90c7c2f68df0b3.png";